import styled from 'styled-components';

export const Wrap = styled.div`

`;

export const TopWrap = styled.div`
  position: relative;

  > div.youtube {
    width: 74%;
    text-align: center;
    position: absolute;
    top: 56.5%;
    left: 50%;
    transform: translateX(-50%);

    > div {
      height: 0;
      padding-top: 56.25%;
      position: relative;
    }

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const BottomWrap = styled.div`
  position: relative;

  > button {
    border: 0;
    background: transparent;
    width: 55.5%;
    height: 10%;
    position: absolute;
    top: 33%;
    left: 50%;
    transform: translateX(-50%);
  }
`;
